<template>
  <div ref="roomContent">
    <van-cell-group>
      <van-cell>
        <div slot="title">
          房间信息 —
          <strong style="color:#00a0c9">每日房价</strong>
        </div>
        <div slot="default" @click="addRoom">
          <van-icon class="add-icon" name="add-o" size="20" color="#f00" />
          添加房间
        </div>
      </van-cell>
    </van-cell-group>
    <van-row class="room-box" v-for="(item, index) in gridData" :key="index">
      <van-col span="3">
        <van-icon
          v-if="!item.Id"
          @click="deleteRoom(index)"
          class="delete"
          name="clear"
          size="25"
          color="#f00"
        />
        <span v-if="item.OrderStatus == 2" class="delete" style="color:#a4a4a4"
          >完成
        </span>
        <span
          v-else-if="item.OrderStatus == 3"
          class="delete"
          style="color:#a4a4a4"
          >暂离
        </span>
        <span
          v-if="item.OrderStatus == 1 && !item.isNew"
          class="delete"
          style="color:#a4a4a4"
          >在住
        </span>
        <div @click="updateRoom(item, index)">
          <span
            v-if="isUpdate && item.OrderStatus == 0 && !item.isNew"
            class="delete"
            >取消</span
          >
          <span
            v-if="isUpdate && item.OrderStatus == 4 && !item.isNew"
            class="delete"
            >恢复</span
          >
        </div>
      </van-col>
      <van-col span="21">
        <van-cell-group class="room-info">
          <van-cell
            :class="{
              'readonly-cls': item.isDisabled,
            }"
          >
            <DateRangePicker
              :min="item.daterange && item.daterange[0]"
              :max="max"
              :value.sync="item.daterange"
              :prop="dateProp"
              :disabled="item.disabled"
              @change="
                (data, status) => handleDateRange(data, item, index, status)
              "
            ></DateRangePicker>
          </van-cell>
          <form-select
            label="房型"
            v-model="item.roomTypeId"
            :readonly="item.isDisabled"
            :columns="roomTypeData"
            @change="data => handleRoomType(data, item, index)"
          ></form-select>
          <form-select
            class="js_roomNo"
            label="房号"
            v-model="item.roomId"
            textKey="No"
            :readonly="item.isDisabled"
            :columns="item.roomNoList"
            @change="data => handleRoomNo(data, item)"
          ></form-select>
          <van-field
            type="number"
            :class="{
              money: true,
              'readonly-cls': item.isDisabled,
            }"
            :readonly="item.isDisabled"
            :value="item.price"
            :disbaled="item.isDisabled"
            label="房费"
            @input="changeRoomPrice($event, item)"
            placeholder="请输入房费"
          />
          <form-select
            label="价构"
            :readonly="item.isDisabled"
            v-model="item.priceStructure"
            :columns="priceStructureData"
            @change="data => handlePriceStructure(data, item, index)"
          ></form-select>
          <van-row>
            <van-col span="24">
              <van-button
                @click="addContact(item, index)"
                plain
                hairline
                type="info"
                :disabled="item.isDisabled"
                block
              >
                <van-icon name="plus" /> 证件*{{
                  item.Persons ? item.Persons.length : 0
                }}</van-button
              >
            </van-col>
          </van-row>
        </van-cell-group>
      </van-col>
    </van-row>
    <van-popup
      v-model="show.showContact"
      close-icon-position="top-left"
      position="top"
      :style="{ height: '100%' }"
    >
      <AddPerson :data="currentPersons" @update="updatePerson"></AddPerson>
    </van-popup>
  </div>
</template>

<script>
import {
  Cell,
  CellGroup,
  Row,
  Col,
  Icon,
  Field,
  NumberKeyboard,
  Popup,
  Dialog,
  Button,
  Notify,
} from "vant";
import { getGSelectData } from "@/api/common.js";
import DateRangePicker from "@/components/date-range-picker/DateRangePicker.vue";
import formSelect from "@/components/form-select";
import AddPerson from "./AddPerson.vue";
import { mapState } from "vuex";
import groupOrderApi from "@/api/group_order.js";
import roomApi from "@/api/room.js";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";
export default {
  name: "roomInfo",
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Field.name]: Field,
    [Notify.name]: Notify,
    [NumberKeyboard.name]: NumberKeyboard,
    [Button.name]: Button,
    [Popup.name]: Popup,
    DateRangePicker,
    formSelect,
    AddPerson,
  },
  props: {
    option: {
      type: Object,
      default: () => {
        return {};
      },
    },
    data: {
      type: Array,
      default: () => [],
    },
    CompanyId: {
      type: String,
      default: "",
    },
    isHourRoom: {
      type: Boolean,
      default: false,
    },
    hourNumber: {
      type: [String, Number],
      default: 0,
    },
    defaultItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
    visible: {
      type: Boolean,
      default: false,
    },
    update: {
      type: Function,
    },
    change: {
      type: Function,
    },
    calculate: {
      type: Function,
    },
  },
  model: {
    props: "option",
    event: "updata",
  },
  watch: {
    gridData: {
      handler: function(/*val*/) {
        // this.$emit("update", val);
        this.$emit("updata", this.roomGridOption);
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
    gridData() {
      return this.option && this.option.gridData ? this.option.gridData : [];
    },
  },
  data() {
    return {
      dateProp: {
        startLabel: "预住",
        endLabel: "预离",
        seperate: false,
      },
      min: "",
      max: "",
      defaultValue: [],
      roomNoData: [],
      priceStructureData: [],
      show: {
        keyboard: false,
        showContact: false,
      },
      roomGridOption: {},
      roomTypeData: [],
      idTypeData: [],
      currentPersons: [],
      currentIndex: 0,
      isUpdate: false,
      isAllCancel: false,
    };
  },
  created() {
    this.roomGridOption = this.option;
    this.isUpdate = this.roomGridOption.actionType == "update";
    this.getRoomSelectData();
    // this.min = this.user.AccountDate;
    this.max = moment(this.user.AccountDate)
      .add(10, "y")
      .format("YYYY-MM-DD");
  },
  methods: {
    /**获取搜索数据，包括房型数据和房间状态数据 */
    getRoomSelectData() {
      //获取房型
      getGSelectData({
        Types: "roomtype",
        CompanyId: this.CompanyId,
      }).then(res => {
        this.roomTypeData = res.Data.roomtype;
      });
      //获取价构列表
      getGSelectData({
        Types: "PriceStructure",
        CompanyId: this.CompanyId,
      }).then(res => {
        this.priceStructureData = res.Data.PriceStructure;
      });
    },
    /**添加房间 */
    addRoom() {
      const lastData = this.gridData[this.gridData.length - 1];
      let daterange = [];
      let inTime = "";
      let outTime = "";
      if (lastData) {
        daterange = [lastData.daterange[0], lastData.daterange[1]];
        inTime = moment(lastData.daterange[0]).format("HH:mm");
        outTime = moment(lastData.daterange[1]).format("HH:mm");
      } else {
        if (this.isHourRoom) {
          const date = moment().format("YYYY-MM-DD");
          inTime = moment().format("HH:mm");
          outTime = moment(date + " " + inTime)
            .add(this.hourNumber, "h")
            .format("HH:mm");
          daterange = [date + " " + inTime, date + " " + outTime];
        } else {
          daterange = [
            this.user.AccountDate,
            moment(this.user.AccountDate)
              .add(1, "d")
              .format("YYYY-MM-DD"),
          ];
        }
      }
      const newRoom = {
        daterange: daterange,
        baseDaterange: daterange,
        days: moment(daterange[1]).diff(moment(daterange[0]), "d"),
        price: "",
        // keyboard: false,
        roomTypeId: "",
        roomTypeName: "",
        roomId: "",
        roomNo: "",
        roomNoList: [],
        TransactionPrices: [
          {
            Date: moment(daterange[0]).format("YYYY-MM-DD"),
            Price: "",
          },
        ],
        BaseTransactionPrices: [
          {
            Date: moment(daterange[0]).format("YYYY-MM-DD"),
            Price: "",
          },
        ],
        Persons: [],
        OrderStatus: this.isHourRoom ? "1" : 0,
        disabled: {
          disabledStart: this.isHourRoom,
          disabledEnd: this.isHourRoom,
        },
        isNew: true,
      };

      this.gridData.push(newRoom);
      this.$emit("calculate");
    },
    /**删除房间 */
    deleteRoom(index) {
      this.gridData.splice(index, 1);
      this.$emit("calculate");
    },
    /**更新房间状态 */
    updateRoom(record /*, index*/) {
      if (record.OrderStatus == 0) {
        Dialog.confirm({
          message: "确认取消订单吗？",
        }).then(() => {
          groupOrderApi
            .GroupCancelDetail({
              Id: record.Id,
              CompanyId: this.CompanyId,
            })
            .then(res => {
              record.OrderStatus = 4;
              record.isDisabled = true;
              this.dateProp.startDisabled = true;
              this.dateProp.endDisabled = true;
              this.isAllCancel =
                res.Data.OrderStatus == 2 ||
                res.Data.OrderStatus == 3 ||
                res.Data.OrderStatus == 4; //所有房间都取消或离店
              this.$emit("calculate", this.isAllCancel);
            });
        });
      } else if (record.OrderStatus == 4) {
        let recoverParam = {
          CompanyId: this.CompanyId,
          OrderDetailId: record.Id,
          RoomId: record.roomId,
          RoomNo: record.roomNo,
          RoomTypeId: record.roomTypeId,
          RoomTypeName: record.roomTypeName,
          PriceCalendars: record.TransactionPrices,
        };
        Dialog.confirm({
          message: "确认恢复该订单吗？",
        }).then(() => {
          groupOrderApi
            .GroupRecoverDetail(recoverParam)
            .then(() => {
              record.OrderStatus = 0;
              this.dateProp.startDisabled = false;
              this.dateProp.endDisabled = false;
              record.isDisabled = false;
            })
            .catch(() => {
              record.isDisabled = false;
            });
        });
      }
    },
    handlePriceStructure(data, item, index) {
      let result = this.priceStructureData.find(
        price => data && price.Id == data.Id && data.Data.Attribute === 1,
      );
      if (result && data) {
        const addPrice = result.Data ? result.Data.Price : 0;
        if (this.gridData[index].TransactionPrices.length && addPrice > 0) {
          this.gridData[index].TransactionPrices = cloneDeep(
            this.gridData[index].BaseTransactionPrices,
          );
          this.gridData[index].TransactionPrices.forEach(item => {
            item.Price = (Number(item.Price) + Number(addPrice)).toFixed(2);
          });
          item.price = this.gridData[index].TransactionPrices[0].Price;
        }
      } else {
        this.gridData[index].TransactionPrices = cloneDeep(
          this.gridData[index].BaseTransactionPrices,
        );
        item.price = this.gridData[index].BaseTransactionPrices[0].Price;
      }
    },
    onInputPrice(item) {
      item.keyboard = false;
      this.gridData.forEach(item => {
        if (item.OrderStatus != 4 && item.OrderStatus != 2) {
          item.TransactionPrices.forEach(el => {
            el.Price = item.price;
          });
        }
      });
      this.$emit("calculate");
    },
    //获取价构的价格
    getAnotherPrice(id) {
      let result = this.priceStructureData.find(
        item => item.Id == id && item.Data.Attribute === 1,
      );
      return result ? result.Data.Price : 0;
    },
    shakeField(index, clsName) {
      let headerTd = this.$refs.roomContent
        .querySelectorAll(".room-box")
        [index].querySelector(clsName);
      this.$common.addClass(headerTd, "shake");
    },
    handleDateRange(data, item, index, status) {
      if (item.OrderStatus == 2 || item.OrderStatus == 4) {
        return;
      }
      //  else if (data[0].valueOf() >= data[1].valueOf()) {
      //   const end1 = moment(data[0])
      //     .add(1, "d")
      //     .format("YYYY-MM-DD");
      //   item.daterange = [data[0], end1];
      // }
      // this.getRoomNos(item, index);
      const _this = this;
      if (
        this.roomGridOption.actionType == "update" &&
        item.days &&
        status == "start"
      ) {
        const end = moment(data[0])
          .add(item.days, "d")
          .format("YYYY-MM-DD");
        item.daterange = [data[0], end];
        this.shakeField(index, ".end-date");
        setTimeout(() => {
          let headerTd = this.$refs.roomContent
            .querySelectorAll(".room-box")
            [index].querySelector(".end-date");
          this.$common.removeClass(headerTd, "shake");
        }, 1000);
      } else if (data[0].valueOf() >= data[1].valueOf() && status == "start") {
        const end1 = moment(data[0])
          .add(1, "d")
          .format("YYYY-MM-DD");
        item.daterange = [data[0], end1];
      } else if (
        item.OrderStatus == 1 &&
        moment(data[1]).isSameOrAfter(this.user.AccountDate) &&
        moment(moment(item.baseDaterange[1]).format("YYYY-MM-DD")).isBefore(
          this.user.AccountDate,
        ) &&
        status == "end"
      ) {
        Dialog.confirm({
          title: "提示",
          message:
            "把离店日期修改超过或等于账务日期时，会将此房间状态修改为在住，并且直接产生入住日到账务日期期间的全日租",
        })
          .then(() => {
            _this.getRoomNos(item, index);
            return;
          })
          .catch(() => {
            item.daterange = cloneDeep(item.baseDaterange);
          });
      }
      _this.getRoomNos(item, index);
    },
    handleRoomType(data, item, index) {
      if (data) {
        if (data.Id == item.roomTypeId) {
          return;
        }
        item.roomTypeId = data.Id;
        item.roomTypeName = data.Text;
        this.getRoomNos(item, index);
      } else {
        item.roomTypeName = "";
        item.roomNo = "";
        item.roomId = "";
        item.roomNoList = [];
      }
    },
    handleRoomNo(data, item) {
      if (data) {
        item.roomNo = data.No;
      } else {
        item.roomNo = "";
      }
    },
    changeRoomPrice(value, item) {
      item.price = value;
      item.TransactionPrices.forEach(el => {
        el.Price = item.price;
      });
      item.BaseTransactionPrices.forEach(el => {
        el.Price = item.price;
      });
    },
    getRoomNos(record, index, status) {
      let headerTd = this.$refs.roomContent
        .querySelectorAll(".room-box")
        [index].querySelector(".js_roomNo");
      this.$common.removeClass(headerTd, "shake");
      let inTime = record.inTime
        ? record.inTime
        : this.defaultItem.ArrivalsTime;
      let outTime = record.outTime
        ? record.outTime
        : this.defaultItem.DepartureTime;
      if (this.isHourRoom) {
        inTime = "";
        outTime = "";
      }
      const params = {
        CheckInTime: record.daterange[0] + " " + inTime,
        CheckOutTime: record.daterange[1] + " " + outTime,
        RoomTypeId: record.roomTypeId,
        CompanyIds: [this.CompanyId],
      };
      if (this.roomGridOption.actionType == "update") {
        params.OrderId = this.roomGridOption.orderId;
      }
      if (!status) {
        params.FilterRoomNos = this.filterRoomNo(this.gridData, index);
      }

      roomApi.GetRoomAvailable(params).then(res => {
        record.roomId = !record.roomId ? "0" : record.roomId;
        record.roomNoList = res.Data.RoomNos;
        let result = res.Data.RoomNos.find(item => item.Id === record.roomId);
        if (!result) {
          this.shakeField(index, ".js_roomNo");
          if (!res.Data.RoomNos.length) {
            Notify({
              type: "warning",
              message:
                "该房型当前日期下没有空房，如继续预定则订单将会变成未排房状态！",
              duration: 5000,
            });
            record.roomId = "";
            record.roomNo = "";
          } else {
            record.roomId = res.Data.RoomNos[0].Id;
            record.roomNo = res.Data.RoomNos[0].No;
          }
        }
        this.$emit("change", record, index);
      });
    },
    //过滤不可用房号
    filterRoomNo(obj, index) {
      const result = [];
      obj.forEach((v, pos) => {
        let prop = {
          CheckInTime: v.daterange[0],
          CheckOutTime: v.daterange[1],
          RoomNo: v.roomNo,
        };
        if (pos !== index) {
          result.push(prop);
        }
      });
      return result;
    },
    addContact(item, index) {
      this.show.showContact = true;
      this.currentPersons = item.Persons;
      this.currentIndex = index;
    },
    updatePerson(data) {
      this.gridData[this.currentIndex].Persons = data;
      if (data.length) {
        this.$emit("update", data[0].Name);
      }
    },
  },
};
</script>
<style lang="less">
.room-box {
  margin: 10px 5px 0 0;
  position: relative;
}
.room-info {
  border: 1px solid #eaeaea;
}
.delete {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  color: #1989fa;
  font-size: 14px;
}
.add-icon {
  position: relative;
  top: 6px;
}
@keyframes shake {
  0% {
    transform: scale(1.02);
    background: #fff1e2;
  }
  25% {
    transform: scale(1.05);
    background: #fff1e2;
  }
  50% {
    transform: scale(1);
    background: #fff1e2;
  }
  75% {
    transform: scale(1.05);
    background: #fff1e2;
  }
  100% {
    transform: scale(1);
    background: #fff;
  }
}
.shake,
.shake /deep/.van-cell {
  -webkit-animation: shake 1s;
  animation: shake 1s;
}
</style>
